"use strict";

angular.module('rmContact', []);

require('./config');
require('./controller');
require('./resources');
require('./directives');
require('./routes');